var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_485_2372)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_485_2372",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0574989H29V29.0575H0V0.0574989Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_485_2372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25213 22.4059L1.34731 20.5011C0.683709 19.8375 0.683709 18.7616 1.34731 18.098L18.0404 1.40481C18.704 0.741264 19.7799 0.741264 20.4435 1.40481L22.3483 3.30969C21.8958 4.25712 22.0618 5.42618 22.8466 6.21094C23.6313 6.99569 24.8004 7.16176 25.7479 6.70915L27.6527 8.61397C28.3163 9.27757 28.3163 10.3535 27.6527 11.0171L10.9595 27.7102C10.2959 28.3738 9.22002 28.3738 8.55647 27.7102L6.65165 25.8054C7.10421 24.858 6.93814 23.6888 6.15338 22.9041C5.36868 22.1194 4.19956 21.9533 3.25213 22.4059Z",
    stroke: "#FF8B3E",
    strokeWidth: 1.69922,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6367 3.80791C18.2246 6.39588 22.306 10.4773 25.249 13.4202",
    stroke: "#FF8B3E",
    strokeWidth: 1.69922,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15.695L4.95152 16.8965",
    stroke: "#FF8B3E",
    strokeWidth: 1.69922,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1621 24.1056L13.3636 25.3071",
    stroke: "#FF8B3E",
    strokeWidth: 1.69922,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7585 21.7026L7.35547 19.2996",
    stroke: "#FF8B3E",
    strokeWidth: 1.69922,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5067 15.5783L16.088 16.3472L15.3502 18.7755L13.8715 16.7128L11.334 16.7615L12.8388 14.7178L12.0084 12.3195L14.4171 13.1191L16.4414 11.5882L16.4252 14.1262L18.5067 15.5783Z",
    stroke: "#FF8B3E",
    strokeWidth: 1.69922,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_485_2372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGem);
export default __webpack_public_path__ + "static/media/gem.2cb1fd901db5f890be0aee17083b1b27.svg";
export { ForwardRef as ReactComponent };